import { defineComponent as H, openBlock as t, createElementBlock as l, mergeProps as d, unref as o, renderSlot as u, createElementVNode as e, createCommentVNode as p } from "vue";
import { useScalarIcon as A } from "../hooks/useScalarIcon.js";
const h = { key: 0 }, i = { key: 1 }, g = { key: 2 }, V = { key: 3 }, f = { key: 4 }, k = { key: 5 }, v = {
  name: "ScalarIconQueue"
}, y = /* @__PURE__ */ H({
  ...v,
  props: {
    label: {},
    weight: {}
  },
  setup(m) {
    const Z = m, { bind: r, weight: n } = A(Z);
    return (s, a) => (t(), l("svg", d({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, o(r)), [
      u(s.$slots, "default"),
      o(n) === "bold" ? (t(), l("g", h, a[0] || (a[0] = [
        e("path", { d: "M28,64A12,12,0,0,1,40,52H216a12,12,0,0,1,0,24H40A12,12,0,0,1,28,64Zm104,52H40a12,12,0,0,0,0,24h92a12,12,0,0,0,0-24Zm0,64H40a12,12,0,0,0,0,24h92a12,12,0,0,0,0-24Zm120-20a12,12,0,0,1-5.64,10.18l-64,40A12,12,0,0,1,164,200V120a12,12,0,0,1,18.36-10.18l64,40A12,12,0,0,1,252,160Zm-34.64,0L188,141.65v36.7Z" }, null, -1)
      ]))) : o(n) === "duotone" ? (t(), l("g", i, a[1] || (a[1] = [
        e("path", {
          d: "M240,160l-64,40V120Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64Zm104,56H40a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Zm0,64H40a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Zm112-24a8,8,0,0,1-3.76,6.78l-64,40A8,8,0,0,1,168,200V120a8,8,0,0,1,12.24-6.78l64,40A8,8,0,0,1,248,160Zm-23.09,0L184,134.43v51.14Z" }, null, -1)
      ]))) : o(n) === "fill" ? (t(), l("g", g, a[2] || (a[2] = [
        e("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM64,72H192a8,8,0,0,1,0,16H64a8,8,0,0,1,0-16Zm40,112H64a8,8,0,0,1,0-16h40a8,8,0,0,1,0,16Zm0-48H64a8,8,0,0,1,0-16h40a8,8,0,0,1,0,16Zm92.44,22.66-48,32A8,8,0,0,1,144,192a8,8,0,0,1-8-8V120a8,8,0,0,1,12.44-6.66l48,32a8,8,0,0,1,0,13.32Z" }, null, -1)
      ]))) : o(n) === "light" ? (t(), l("g", V, a[3] || (a[3] = [
        e("path", { d: "M34,64a6,6,0,0,1,6-6H216a6,6,0,0,1,0,12H40A6,6,0,0,1,34,64Zm102,58H40a6,6,0,0,0,0,12h96a6,6,0,0,0,0-12Zm0,64H40a6,6,0,0,0,0,12h96a6,6,0,0,0,0-12Zm110-26a6,6,0,0,1-2.82,5.09l-64,40A6,6,0,0,1,170,200V120a6,6,0,0,1,9.18-5.09l64,40A6,6,0,0,1,246,160Zm-17.32,0L182,130.83v58.34Z" }, null, -1)
      ]))) : o(n) === "regular" ? (t(), l("g", f, a[4] || (a[4] = [
        e("path", { d: "M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64Zm104,56H40a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Zm0,64H40a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Zm112-24a8,8,0,0,1-3.76,6.78l-64,40A8,8,0,0,1,168,200V120a8,8,0,0,1,12.24-6.78l64,40A8,8,0,0,1,248,160Zm-23.09,0L184,134.43v51.14Z" }, null, -1)
      ]))) : o(n) === "thin" ? (t(), l("g", k, a[5] || (a[5] = [
        e("path", { d: "M36,64a4,4,0,0,1,4-4H216a4,4,0,0,1,0,8H40A4,4,0,0,1,36,64Zm100,60H40a4,4,0,0,0,0,8h96a4,4,0,0,0,0-8Zm0,64H40a4,4,0,0,0,0,8h96a4,4,0,0,0,0-8Zm108-28a4,4,0,0,1-1.88,3.39l-64,40A4,4,0,0,1,176,204a4.06,4.06,0,0,1-1.94-.5A4,4,0,0,1,172,200V120a4,4,0,0,1,6.12-3.39l64,40A4,4,0,0,1,244,160Zm-11.55,0L180,127.22v65.56Z" }, null, -1)
      ]))) : p("", !0)
    ], 16));
  }
});
export {
  y as default
};
